module.exports = __webpack_public_path__ + "static/media/year2021_1-tc.af4d890e.jpg";